import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import type React from "react";
interface FlagProps extends React.SVGAttributes<SVGSVGElement> {
  size?: string;
  className?: string;
}
const UnitedKingdomFlag: React.FC<FlagProps> = t0 => {
  const $ = _c(14);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? "1em" : t1;
  let t2;
  if ($[4] !== className) {
    t2 = clsx("icon", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="#00247d" d="M0 9.059V13h5.628zM4.664 31H13v-5.837zM23 25.164V31h8.335zM0 23v3.941L5.63 23zM31.337 5H23v5.837zM36 26.942V23h-5.631zM36 13V9.059L30.371 13zM13 5H4.664L13 10.837z" />;
    t4 = <path fill="#cf1b2b" d="M25.14 23l9.712 6.801a3.977 3.977 0 0 0 .99-1.749L28.627 23H25.14zM13 23h-2.141l-9.711 6.8c.521.53 1.189.909 1.938 1.085L13 23.943V23zm10-10h2.141l9.711-6.8a3.988 3.988 0 0 0-1.937-1.085L23 12.057V13zm-12.141 0L1.148 6.2a3.994 3.994 0 0 0-.991 1.749L7.372 13h3.487z" />;
    t5 = <path fill="#eee" d="M36 21H21v10h2v-5.836L31.335 31H32a3.99 3.99 0 0 0 2.852-1.199L25.14 23h3.487l7.215 5.052c.093-.337.158-.686.158-1.052v-.058L30.369 23H36v-2zM0 21v2h5.63L0 26.941V27c0 1.091.439 2.078 1.148 2.8l9.711-6.8H13v.943l-9.914 6.941c.294.07.598.116.914.116h.664L13 25.163V31h2V21H0zM36 9a3.983 3.983 0 0 0-1.148-2.8L25.141 13H23v-.943l9.915-6.942A4.001 4.001 0 0 0 32 5h-.663L23 10.837V5h-2v10h15v-2h-5.629L36 9.059V9zM13 5v5.837L4.664 5H4a3.985 3.985 0 0 0-2.852 1.2l9.711 6.8H7.372L.157 7.949A3.968 3.968 0 0 0 0 9v.059L5.628 13H0v2h15V5h-2z" />;
    t6 = <path fill="#cf1b2b" d="M21 15V5h-6v10H0v6h15v10h6V21h15v-6z" />;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[10] !== props || $[11] !== size || $[12] !== t2) {
    t7 = <svg width={size} height={size} viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className={t2} preserveAspectRatio="xMidYMid meet" {...props}>{t3}{t4}{t5}{t6}</svg>;
    $[10] = props;
    $[11] = size;
    $[12] = t2;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
export default UnitedKingdomFlag;